import { Typography } from '@mui/material';
import { Interpretation, MeasureComparison } from 'components/MeasureComparison';
import { MeasureFormat } from 'components/measure-unit/MeasureFormat';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { MatrixValue } from 'pages/trading/price/promotion/PricePromotionDetailPage';

export interface MatrixCardProps {
  cardDetails: MatrixValue;
  measureUnitCode: MeasureUnitCode;
  priceColumn: boolean;
  initialPrice?: boolean;
  isLast?: boolean;
}

export function MatrixCard({
  cardDetails,
  measureUnitCode,
  priceColumn,
  initialPrice = false,
  isLast = false,
}: MatrixCardProps) {
  return (
    <div
      className={`col-span-2 xl:col-span-2 flex flex-col h-full py-4 cursor-default items-center justify-center${isLast ? '' : ' border-b-2'}`}
    >
      <Typography variant="h1" sx={{ fontWeight: 700, fontSize: '30px' }}>
        {!initialPrice && (
          <MeasureFormat value={cardDetails.value} unit={measureUnitCode} config={{ decimalPlaces: 2 }} />
        )}
        {initialPrice && <span className="text-right">-</span>}
      </Typography>

      {!priceColumn && (
        <div className="flex items-center gap-2">
          {cardDetails.comparisonValue != null && (
            <>
              <MeasureComparison
                value={cardDetails.value}
                comparisonValue={cardDetails.comparisonValue ?? null}
                unit={measureUnitCode}
                interpretation={Interpretation.POSITIVE}
              />
              {!priceColumn && (
                <Typography variant="caption" sx={{ fontSize: '12px', color: 'text.secondary' }}>
                  vs. before promotion
                </Typography>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}
